// removed by extract-text-webpack-plugin
module.exports = {"line-item":"DeviceLine__line-item","lineItem":"DeviceLine__line-item","line-type":"DeviceLine__line-type","lineType":"DeviceLine__line-type","mobilesmartphone":"DeviceLine__mobilesmartphone","tablets":"DeviceLine__tablets","wearables":"DeviceLine__wearables","line-item-label":"DeviceLine__line-item-label","lineItemLabel":"DeviceLine__line-item-label","line-counter":"DeviceLine__line-counter","lineCounter":"DeviceLine__line-counter"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/wireless-ui/components/DeviceCountPanel/DeviceLine/DeviceLine.scss
// module id = 1726
// module chunks = 8